import api from 'Cloud/Application/api';
import { logger } from 'lib/logger';
import { GetFamilyFolderListCall } from 'reactApp/api/family/GetFamilyFolderListCall';
import { IS_FAMILY_USER } from 'reactApp/appHelpers/configHelpers';
import { familyFoldersInShared } from 'reactApp/appHelpers/featuresHelpers/features/familyFoldersInShared';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { isUserWithFamily } from 'reactApp/modules/family/family.selectors';
import { mountRequest, unmountRequest } from 'reactApp/modules/modifying/modifying.actions';
import { historyPush } from 'reactApp/modules/router/router.module';
import { ESortOder } from 'reactApp/modules/sort/sort.types';
import { ETreeRootIds } from 'reactApp/ui/TreeComponent/TreeComponent.constants';
import { put, select, takeEvery } from 'redux-saga/effects';

import { loadIncomingRequest, loadIncomingStartRequest, loadIncomingSuccess } from './incoming.module';
import { getWaitingAccceptIncomingItemByInviteToken } from './incoming.selectors';

const getFolderListCall = () => new GetFamilyFolderListCall().makeRequest({ order: ESortOder.desc });

function* loadIncoming() {
    try {
        yield put(loadIncomingRequest());
        let { list } = yield Promise.resolve(api.folder.shared.incoming());

        /**
         * CLOUD-4650: Уберем, как на бэкенде будут проставлять правильные флаги
         */
        const withFamily = yield select(isUserWithFamily);
        if (!familyFoldersInShared && (withFamily || IS_FAMILY_USER)) {
            const familyList = (yield getFolderListCall())?.data?.list;
            if (familyList) {
                list = list.filter(
                    (item) => !familyList.find((familyItem) => familyItem?.home?.toLowerCase() === item?.home?.toLowerCase())
                );
            }
        }
        yield put(
            loadIncomingSuccess({
                list: [...list],
            })
        );

        const { token, action } = yield select(getQueryParams);

        if (token && action) {
            const requestedFolder = yield select(getWaitingAccceptIncomingItemByInviteToken, token);
            yield put(historyPush({ id: ETreeRootIds.sharedIncoming }));

            if (action === 'accept' && requestedFolder) {
                yield put(mountRequest({ item: requestedFolder }));
            }

            if (action === 'reject' && requestedFolder) {
                yield put(unmountRequest({ item: requestedFolder }));
            }
        }
    } catch (error) {
        logger.error(error);
    }
}

export function* watchIncoming() {
    yield takeEvery(loadIncomingStartRequest.toString(), loadIncoming);
}
